"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var React = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

var _Spinner = require("../Icon/Spinner");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n 0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

const spinnerSpin = (0, _core.keyframes)(_templateObject());
const StyledIcon = ( /*#__PURE__*/0, _styledBase.default)(_Spinner.IconSpinner, {
  target: "e1pla2t60",
  label: "StyledIcon"
})("animation:", spinnerSpin, " 1s infinite cubic-bezier(0.35,0.3,0.3,0.35);");

/**
 * Offers solace and mutual understanding that a task of unknowable duration (but usually short) is ongoing.
 */
const Spinner = (_ref) => {
  let restProps = _extends({}, _ref);

  return (0, _core.jsx)(StyledIcon, restProps);
};

exports.Spinner = Spinner;